import { useMemo, useRef } from 'react';

import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';

export type TapTraitResult<T> = {
	value: T | undefined;
	loading: boolean;
	error: Error | null;
};

export type BannerTraitHookOptions = {
	skip?: boolean;
};

export function useTapTrait<T>(
	traitName: string,
	parse: (rawValue: string | undefined) => T | undefined,
	{ skip }: BannerTraitHookOptions = {},
): TapTraitResult<T> {
	const { data, loading, error } = useSiteTraits({ skipBootstrap: !!skip });

	const parseRef = useRef(parse);
	parseRef.current = parse;

	const value = useMemo(() => {
		if (skip || !data?.attributes) {
			return undefined;
		}
		const raw = data.attributes.find(({ name }) => name === traitName)?.value;
		return parseRef.current(raw);
	}, [skip, data, traitName]);

	return { value, loading, error };
}
